import {ReactNode} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {ListEntityType, ListPropsType, QueryParamsProps}
  from '../../constants/types';
import TableHeaderRow from './TableHeaderRow';
import IconButton from '@mui/material/IconButton';

type ListTableProps = {
  entity: ListEntityType;
  content: ListPropsType[],
  query: QueryParamsProps,
  rowRenderer?: (content: any) => ReactNode,
  inlineAdd?: ReactNode
}

export const ListTable = ({
  entity,
  content,
  rowRenderer,
  inlineAdd,
  query
}: ListTableProps) => {
  const history = useHistory();
  const tableData = entity?.['fields'];

  const renderRows = () => content
      .map((rowItem, rowIndex: number) => {
        const rowCells = tableData.map((cellData) => {
          const {name, secondName, internal, link, icon} = cellData;

          const mergedLabel = secondName ?
            [rowItem[name], rowItem[secondName]].join(', ') : rowItem[name];
          const label = internal ? rowItem[name]?.[internal] : mergedLabel;

          if (icon && link) {
            return (
              <td key={`${name}-row-${rowIndex}`} className="cell">
                <IconButton
                  onClick={() => history.push(link(rowItem?.id))}
                  className="icon-button gray small"
                >
                  {icon}
                </IconButton>
              </td>
            );
          }

          return (
            <td
              key={`${name}-row-${rowIndex}`}
              className="cell">
              {!!link ? (
                <Link to={link(rowItem?.id)} className="link">
                  {label}
                </Link>
              ) : label}
            </td>
          );
        });

        return (
          <tr className="row" key={rowItem.id}>
            {rowCells}
          </tr>
        );
      });

  return (
    <table className="table">
      <thead>
        <TableHeaderRow
          query={query}
          tableData={tableData}
          hasIconComponent={false}
        />
        {!!inlineAdd && inlineAdd}
      </thead>
      <tbody>
        {rowRenderer ? rowRenderer(content) : renderRows()}
      </tbody>
    </table>
  );
};
